import L from 'leaflet';
import { memo, useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';

import { LAYER_PARAMS } from '~/helpers/supply';

import type React from 'react';
import type { Nullable } from '~/types/generics';

const AnimatedTileLayer: React.FC<{
  url: string;
  bounds: L.LatLngBoundsExpression;
  className?: string;
  zIndex?: number;
  duration?: number;
}> = ({ url, bounds, className, zIndex = 1, duration = 500 }) => {
  const map = useMap();
  const tileLayerRef = useRef<Nullable<L.TileLayer>>(null);

  useEffect(() => {
    const tileLayer = L.tileLayer(url, {
      ...LAYER_PARAMS,
      className,
      zIndex,
      opacity: 0,
      bounds,
    });

    tileLayer.addTo(map);

    const container = tileLayer.getContainer();
    if (container) {
      container.style.transition = `opacity ${duration}ms ease-in-out`;
    }

    requestAnimationFrame(() => {
      tileLayer.setOpacity(1);
    });

    tileLayerRef.current = tileLayer;

    return () => {
      if (tileLayerRef.current) {
        tileLayerRef.current.setOpacity(0);

        // Wait for the animation to complete before removing the layer
        setTimeout(() => {
          if (tileLayerRef.current) {
            map.removeLayer(tileLayerRef.current);
            tileLayerRef.current = null;
          }
        }, duration);
      }
    };
  }, [map, url, bounds, className, zIndex, duration]);

  return null;
};

export default memo(AnimatedTileLayer);
